export class AgentTunnelSession {
    id: number;
    installationName: string;
    servicePort: number;
    port: number;
    portType: string;
    portSerialNumber: string;
    startDate: Date;
    endDate: Date;

    public parse(obj: any) {
        if (obj.Id != null && obj.Id != undefined) this.id = obj.Id;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.ServicePort != null && obj.ServicePort != undefined) this.servicePort = obj.ServicePort;
        if (obj.Port != null && obj.Port != undefined) this.port = obj.Port;
        if (obj.PortType) this.portType = obj.PortType;
        if (obj.PortSerialNumber) this.portSerialNumber = obj.PortSerialNumber;
        if (obj.StartDate) this.startDate = obj.StartDate;
        if (obj.EndDate) this.endDate = obj.EndDate;
    }
}
